module.exports = __webpack_public_path__ + "img/trainingsschema-week-1-3.e4e59c80.png";